import { render, staticRenderFns } from "./dots.vue?vue&type=template&id=41331868"
import script from "./dots.vue?vue&type=script&lang=js"
export * from "./dots.vue?vue&type=script&lang=js"
import style0 from "./dots.vue?vue&type=style&index=0&id=41331868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports